const REQUEST_FIELDS = `
  id
  contact_id
  contact {
    id
    firstname
    lastname
    email
  }
  request_reason_id
  request_reason {
    id
    name
    translation_key
    manual
    contact_type
    parameters
  }
  status_id
  request_status {
    id
    name
  }
  description
  data
  decision_message
  decision_date
  decision_user_id
  continue_as_member
  group_change
  contact_member_retention
  new_group_id
  send_leave_poll
  created_by
  its
  uts
`;

export const CREATE_REQUEST = `
  mutation createRequest(
    $input: CreateRequestInput!
    $tenant_id: Int!
  ) {
    createRequest(
      input: $input
      tenant_id: $tenant_id
    ) {
      __typename
      ... on Request {
        ${REQUEST_FIELDS}
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const EDIT_PENDING_REQUEST = `
  mutation editPendingRequest(
    $input: UpdateRequestInput!
    $tenant_id: Int!
  ) {
    editPendingRequest(
      input: $input
      tenant_id: $tenant_id
    ) {
      __typename
      ... on Request {
        ${REQUEST_FIELDS}
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const APPROVE_REQUEST = `
  mutation approveRequest(
    $input: RequestDecisionInput!
    $tenant_id: Int!
  ) {
    approveRequest(
      input: $input
      tenant_id: $tenant_id
    ) {
      __typename
      ... on Request {
        ${REQUEST_FIELDS}
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const REJECT_REQUEST = `
  mutation rejectRequest(
    $input: RequestDecisionInput!
    $tenant_id: Int!
  ) {
    rejectRequest(
      input: $input
      tenant_id: $tenant_id
    ) {
      __typename
      ... on Request {
        ${REQUEST_FIELDS}
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const CANCEL_REQUEST = `
  mutation cancelRequest(
    $input: RequestDecisionInput!
    $tenant_id: Int!
  ) {
    cancelRequest(
      input: $input
      tenant_id: $tenant_id
    ) {
      __typename
      ... on Request {
        ${REQUEST_FIELDS}
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const LOGIC_DELETE_REQUEST = `
  mutation logicDeleteRequest(
    $id: Float!
    $tenant_id: Int!
  ) {
    logicDeleteRequest(
      id: $id
      tenant_id: $tenant_id
    ) {
      __typename
      ... on Request {
        ${REQUEST_FIELDS}
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const FINALIZE_REQUEST = `
  mutation finalizeRequest(
    $input: RequestDecisionInput!
    $tenant_id: Int!
  ) {
    finalizeRequest(
      input: $input
      tenant_id: $tenant_id
    ) {
      __typename
      ... on Request {
        ${REQUEST_FIELDS}
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
